import { render, staticRenderFns } from "./QrCodeDownloadLink.vue?vue&type=template&id=28416278&"
import script from "./QrCodeDownloadLink.vue?vue&type=script&lang=js&"
export * from "./QrCodeDownloadLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports